// AppRoutes.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import DashBoardPage from "./pages/DashboardPage";
import Unauthorized from "./pages/UnAuthorizedPage";
import { ProtectedRoute } from "./context/ProtectedRoute";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import ChallengesPage from "./pages/ChallengesPage";
import AddChallengePage from "./pages/Admin Panel/AddChallengePage";
import ManageUserPage from "./pages/Admin Panel/ManageUserPage";
import ManageChallengePage from "./pages/Admin Panel/ManageChallengePage";
import LeaderBoardPage from "./pages/LeaderBoardPage";
import SettingsPage from "./pages/SettingsPage";
import AboutUsPage from "./pages/AboutUsPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import MyReportPage from "./pages/MyReportPage";
import AddEventPage from "./pages/Admin Panel/AddEventPage";
import ManageEventPage from "./pages/Admin Panel/ManageEventPage";
import ReportEvaluationPage from "./pages/EvaluationReportPage";
import AddUserPage from "./pages/Admin Panel/AddUserPage";
import ReportDetailPage from "./pages/ReportDetailPage";
import EventDetailPage from "./pages/EventDetailPage";
import EventInfoPage from "./pages/Admin Panel/EventInfoPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import EditEvent from "./pages/Admin Panel/EditEventPage";
import EditChallenge from "./pages/Admin Panel/EditChallengePage";
import LearnPage from "./pages/LearnPage";
import LandingPage from "./pages/LandingPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<ProtectedRoute><Unauthorized /></ProtectedRoute>} />
      <Route path="/" element={<LandingPage />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/aboutus" element={<AboutUsPage />} />
      <Route path="/termsofservice" element={<TermsOfServicePage />} />
      <Route path="/resetpassword" element={<ResetPasswordPage />} />
      <Route path="/challenges" element={<ProtectedRoute><ChallengesPage /></ProtectedRoute>} />
      <Route path="/learning" element={<ProtectedRoute><LearnPage /></ProtectedRoute>} />
      <Route path="/addchallenge" element={<ProtectedRoute> <AddChallengePage /></ProtectedRoute>} />
      <Route path="/manageuser" element={<ProtectedRoute><ManageUserPage /></ProtectedRoute>} />
      <Route path="/managechallenge" element={<ProtectedRoute><ManageChallengePage /></ProtectedRoute>} />
      <Route path="/evaluatereport" element={<ProtectedRoute><ReportEvaluationPage /></ProtectedRoute>} />
      <Route path="/evaluatereport/:id" element={<ProtectedRoute><ReportDetailPage /></ProtectedRoute>} />
      <Route path="/event/:id" element={<ProtectedRoute><EventDetailPage /></ProtectedRoute>} />
      <Route path="/manageevent/:id" element={<ProtectedRoute><EventInfoPage /></ProtectedRoute>} />
      <Route path="/managechallenge/:id" element={<ProtectedRoute><EditChallenge /></ProtectedRoute>} />
      <Route path="/manageevent" element={<ProtectedRoute><ManageEventPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute> <DashBoardPage /></ProtectedRoute>} />
      <Route path="/leaderboard" element={<ProtectedRoute><LeaderBoardPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/adduser" element={<ProtectedRoute><AddUserPage /></ProtectedRoute>} />
      <Route path="/myreport" element={<ProtectedRoute><MyReportPage /></ProtectedRoute>} />
      <Route path="/addevent" element={<ProtectedRoute><AddEventPage /></ProtectedRoute>} />
      <Route path="/manageevent/edit/:id" element={<ProtectedRoute> <EditEvent /> </ProtectedRoute>} />
      <Route path="/landing" element={<LandingPage />} />
    </Routes>
  );
};

export default AppRoutes;
